function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5759 10.5C20.2328 10.5 21.5759 11.8431 21.5759 13.5V19.5C21.5759 21.1569 20.2328 22.5 18.5759 22.5H6.57593C4.91907 22.5 3.57593 21.1569 3.57593 19.5V13.5C3.57593 11.8431 4.91907 10.5 6.57593 10.5V7.5C6.57593 4.18629 9.26222 1.5 12.5759 1.5C15.8896 1.5 18.5759 4.18629 18.5759 7.5V10.5ZM12.5759 3.5C14.7851 3.5 16.5759 5.29086 16.5759 7.5V10.5H8.57593V7.5C8.57593 5.29086 10.3668 3.5 12.5759 3.5ZM18.5759 12.5H6.57593C6.02364 12.5 5.57593 12.9477 5.57593 13.5V19.5C5.57593 20.0523 6.02364 20.5 6.57593 20.5H18.5759C19.1282 20.5 19.5759 20.0523 19.5759 19.5V13.5C19.5759 12.9477 19.1282 12.5 18.5759 12.5Z",
  fill: "#9FA2B4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5759,
  cy: 15.625,
  r: 1.5,
  fill: "#9FA2B4"
});

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.00117c7a.svg";
export { ForwardRef as ReactComponent };